import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box} from 'views/components';
import {translate} from 'views/module';

import DomainGuideColumn from './column/DomainGuideColumn';

import {formatCreatedByLabel, isUserRn} from '../utils/createdBy';

import backend from 'utils/backend';

const DomainGuideList = (props) => {
  const {
    statusProgressWrap: progressWrap,
  } = props;
  const [domainGuides, setDomainGuides] = React.useState([]);
  const [createdByLabelsByRn, setCreatedByLabelsByRn] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    let isActive = true;

    const loadDomainGuides = async () => {
      setIsLoading(true);

      try {
        await progressWrap(async () => {
          const domainGuideResponse = await backend.domainGuide.listDomainGuides();
          const domainGuideList = Array.isArray(domainGuideResponse) ? domainGuideResponse : domainGuideResponse?.list;
          const createdByRns = [...new Set((domainGuideList || []).map((domainGuideData) => domainGuideData.createdBy).filter(isUserRn))];
          const createdByLabelEntries = await Promise.all(createdByRns.map(async (createdByRn) => {
            try {
              const userResponse = await backend.user.getUser(createdByRn, false);

              return [createdByRn, formatCreatedByLabel(userResponse?.user, createdByRn)];
            } catch {
              return [createdByRn, createdByRn];
            }
          }));

          if (isActive) {
            setDomainGuides(domainGuideList || []);
            setCreatedByLabelsByRn(Object.fromEntries(createdByLabelEntries));
          }
        });
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    loadDomainGuides();

    return () => {
      isActive = false;
    };
  }, [progressWrap]);

  const domainGuideStatuses = [
    {status: 'ACTIVE', title: translate('domainGuide.Status.ACTIVE.ColumnTitle')},
    {status: 'INACTIVE', title: translate('domainGuide.Status.INACTIVE.ColumnTitle')},
    {status: 'DELETED', title: translate('domainGuide.Status.DELETED.ColumnTitle')},
  ];
  const getDomainGuideName = (domainGuideData) => domainGuideData.name || '';
  const getDomainGuideCreatedTime = (domainGuideData) => {
    const createdAtDate = new Date(domainGuideData.createdAt);

    return Number.isNaN(createdAtDate.getTime()) ? 0 : createdAtDate.getTime();
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: {
          md: 'calc(99vh - 32px)',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
          p: 3,
          overflowX: 'auto',
        }}
      >
        {
          domainGuideStatuses.map((domainGuideStatus) => {
            const statusDomainGuides = domainGuides
                .filter((domainGuideData) => domainGuideData.status === domainGuideStatus.status)
                .sort((firstDomainGuide, secondDomainGuide) => {
                  const firstCreatedTime = getDomainGuideCreatedTime(firstDomainGuide);
                  const secondCreatedTime = getDomainGuideCreatedTime(secondDomainGuide);

                  if (firstCreatedTime !== secondCreatedTime) {
                    return secondCreatedTime - firstCreatedTime;
                  }

                  return getDomainGuideName(firstDomainGuide).localeCompare(getDomainGuideName(secondDomainGuide));
                });

            return (
              <DomainGuideColumn
                key={domainGuideStatus.status}
                title={domainGuideStatus.title}
                domainGuides={statusDomainGuides}
                createdByLabelsByRn={createdByLabelsByRn}
                isLoading={isLoading}
              />
            );
          })
        }
      </Box>
    </Box>
  );
};

DomainGuideList.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(DomainGuideList));
